let maps = {};

let gapi_script = document.createElement('script');
gapi_script.src = 'https://maps.googleapis.com/maps/api/js?key=' + google_api_key + '&callback=initMap';
document.head.appendChild(gapi_script);

let marker;

const initMap = () => {
	map = new google.maps.Map(document.getElementById('activities-detail-map'), {
		center: gpsPoint,
		zoom: 16
	});

	infoWindow = new google.maps.InfoWindow({
	});

	if (gpsPoints) {
		map_markers = [];
		for (var ic in gpsPoints) {
			if (gpsPoints.hasOwnProperty(ic)) {
				var marker = new google.maps.Marker({
					position: {lat: gpsPoints[ic].gps_lat, lng: gpsPoints[ic].gps_lng},
					map: map,
					info: gpsPoints[ic].title,
					id: gpsPoints[ic].id,
					title: gpsPoints[ic].title,
					url: gpsPoints[ic].url,
					icon: '/assets/svg/icon_map_pin.svg'
				});

				google.maps.event.addListener(marker, 'click', function () {
					infoWindow.setContent(this.info);
					infoWindow.open(map, this);
				});

				map_markers.push(marker);
			}
		}
		var bounds = new google.maps.LatLngBounds();
		for (var i = 0; i < map_markers.length; i++) {
			bounds.extend(map_markers[i].getPosition());
		}
		map.fitBounds(bounds);
	}else {
		if (gpsPoint) {
			var marker = new google.maps.Marker({
				position: gpsPoint,
				map: map,
				icon: '/assets/svg/icon_map_pin.svg'
			});
		}
	}
};

/** MAP */
$(window)
	.scroll(function () {
		activities_detail_map_scroll();
	})
	.resize(function () {
		activities_detail_map_scroll();
	});

$('.activities-content-map-icon,.activities-map-header .close, #mobile-control-button-map').click(function () {
	$('.activities-map').toggleClass('show');

	var html = $('html');
	if (html.hasClass('no-scroll'))
		html.removeClass('no-scroll');
	else if ($(window).width() <= 440 || $(window).height() <= 500)
		html.addClass('no-scroll');
});

let pageGallery = $('.page-gallery'),
	pageContentLeft = $('.page-content-left'),
	activitiesMap = $('.activities-map-detail');

function activities_detail_map_scroll() {
	let st = $(window).scrollTop(),
		header_height = $(window).width() >= 580 ? 110 : 84,
		height = $(window).height() - header_height;

	pageContentLeft.css('min-height', height);

	let pos_bottom = st + $(window).height() - pageContentLeft.offset().top - pageContentLeft.outerHeight();
	//
	if (pos_bottom < 0)
		pos_bottom = 0;
	//
	if ($(window).width() > 768) {
		if (st <= (pageContentLeft.offset().top - header_height) || pos_bottom !== 0) {
			if (st > pageContentLeft.offset().top - header_height) {
				activitiesMap.css('top', pageContentLeft.outerHeight() - height);
			} else {
				activitiesMap.css('top', 0);
			}

			activitiesMap
				.css({
					'position': 'relative',
					'left': 0,
					'right': 0,
					'width': '100%',
					'height': height + 'px'
				});
		} else {
			activitiesMap
				.css({
					'position': 'fixed',
					'top': 'auto',
					'left': '66.5805%',
					'right': 0,
					'bottom': 0,
					'width': '33.4195%',
					'-webkit-transform': 'translateY(0)',
					'-moz-transform': 'translateY(0)',
					'-ms-transform': 'translateY(0)',
					'-o-transform': 'translateY(0)',
					'transform': 'translateY(0)'
				});
		}
		activitiesMap
			.css('height', height + 'px')
			.css('z-index', 1);
	} else {
		activitiesMap.removeAttr('style');
	}
}

activities_detail_map_scroll();